import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

/**
 * オンラインスピーキングSSOOneTimeKey情報取得
 */
import { ApiTaLi150 } from '~/endpoints/ApiTaLi150'
import { logger } from '~/utils/logger'

export interface StateOnlineSpeakingSSOOneTimeKey {
  url: string
  oneTimeKey: string
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}

export interface ActionParamsOnlineSpeakingSSOOneTimeKey {
  courseId: string // コースID（必須）
  previousMonthCount: number // 契約開始月の何ヶ月前から有効とするか（必須、0以上）
  overDayCount: number // 契約完了月の何日後まで有効とするか（必須、0以上）
}

// 初期ステート
const getEmptyState = (): StateOnlineSpeakingSSOOneTimeKey => ({
  url: '',
  oneTimeKey: '',
  statusCode: 0,
  error: null,
})

@Module({
  name: 'apis/OnlineSpeakingSSOOneTimeKey',
  stateFactory: true,
  namespaced: true,
})
export default class OnlineSpeakingSSOOneTimeKey extends VuexModule {
  public url: string = ''
  public oneTimeKey: string = ''
  public statusCode: number = 0
  public error: StateOnlineSpeakingSSOOneTimeKey['error'] = null

  get address(): string {
    if (this.error !== null || !this.url) {
      return ''
    }
    // 旧SSOと同様に、urlとoneTimeKeyを組み合わせて完全なURLを返す
    return this.url + '?OneTimeKey=' + this.oneTimeKey
  }

  @Mutation
  updateState(payload: StateOnlineSpeakingSSOOneTimeKey) {
    this.url = payload.url
    this.oneTimeKey = payload.oneTimeKey
    this.statusCode = payload.statusCode
    this.error = payload.error
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateState'

  @Action
  clear() {
    this.context.commit(OnlineSpeakingSSOOneTimeKey.MUTATION_NAME_UPDATE_STATE, getEmptyState())
  }

  @Action
  async get(param: ActionParamsOnlineSpeakingSSOOneTimeKey) {
    logger.trace('in: OnlineSpeakingSSOOneTimeKey.get')

    const api = new ApiTaLi150.Api()

    const result = await api.get<StateOnlineSpeakingSSOOneTimeKey | null>(
      {
        query: {
          courseId: param.courseId,
          previousMonthCount: param.previousMonthCount,
          overDayCount: param.overDayCount,
        },
      },
      // Success
      (data, status) => ({
        url: data.url,
        oneTimeKey: data.oneTimeKey,
        statusCode: status,
        error: null,
      }),
      // Error
      (data, status) => {
        logger.error(status, data)
        return {
          url: '',
          oneTimeKey: '',
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitData = result || getEmptyState()
    this.context.commit(OnlineSpeakingSSOOneTimeKey.MUTATION_NAME_UPDATE_STATE, commitData)
  }
}
